import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { Header } from "@/components/site/Header";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Footer } from "@/components/site/Footer";
import { Seo } from "@/components/site/Seo";
import { Reveal } from "@/components/site/Reveal";
import { GUIDES } from "@/data/guides";

const SITE = "https://treasurevalleyturf.com";

export default function Guides() {
    return (
        <div data-testid="guides-page" className="relative min-h-screen bg-white text-brand-text">
            <Seo
                title="Turf & Putting Green Guides for Idaho | Treasure Valley Turf & Greens"
                description="Plain-English guides on artificial turf costs, pet safety, lifespan, and putting greens in Idaho — from a Treasure Valley installer with 25+ years of experience."
                canonical={`${SITE}/guides`}
            />
            <ServiceArea />
            <Header />

            <main className="mx-auto max-w-7xl px-6 pb-24 pt-44 md:px-10 md:pt-56">
                <Reveal>
                    <p className="mb-6 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] text-brand-accent">
                        <span aria-hidden className="h-px w-10 bg-brand-accent/70" />
                        Guides & honest answers
                    </p>
                </Reveal>
                <Reveal delay={0.08}>
                    <h1 className="font-display max-w-3xl text-balance text-4xl font-semibold leading-[1.02] tracking-tight md:text-6xl">
                        Everything Idaho homeowners ask us{" "}
                        <span className="italic text-brand-accent">before they buy turf</span>.
                    </h1>
                </Reveal>

                <div className="mt-14 grid gap-5 md:grid-cols-2">
                    {GUIDES.map((g, i) => (
                        <Reveal key={g.slug} delay={i * 0.06}>
                            <Link
                                to={`/guides/${g.slug}`}
                                data-testid={`guide-card-${g.slug}`}
                                className="group flex h-full flex-col rounded-3xl border border-brand-border bg-white p-7 transition-colors duration-500 hover:border-brand-accent/40"
                            >
                                <div className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.18em] text-brand-muted">
                                    <span className="rounded-full bg-brand-accent/10 px-3 py-1 text-brand-accent">{g.category}</span>
                                    <span>{g.readTime}</span>
                                </div>
                                <h2 className="font-display mt-5 text-2xl font-medium leading-snug tracking-tight transition-colors group-hover:text-brand-accent">
                                    {g.title}
                                </h2>
                                <p className="mt-3 flex-1 text-sm leading-relaxed text-brand-muted">{g.description}</p>
                                <span className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-brand-accent">
                                    Read the guide
                                    <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-1" />
                                </span>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </main>

            <Footer />
        </div>
    );
}
